import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { numberWithCommas } from "../../../../helpers/dataHelpers";
import { Toolbar, IconButton } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { connect } from "react-redux";
import { openModal } from "../../../../store/actions/ModalActions";
import PieChartLoader from "../../../../components/extensions/PieChartLoader";

import { GetCustomerProfileOverallV4 } from "../../../../store/actions/reports-v4/customer_profiling_service_actions";
import CustomerProfileViewFilter from "../../view_filters/CustomerProfile/CustomerProfileViewFilter";
import ModuleLocked from "../../../../components/extensions/ModuleLockedView";
import {
  moduleNames,
  OperationScope,
} from "../../../../helpers/dashboardModuleNames";
import { DashboardContext } from "../../dashboard_context";
import NoTableData from "../../../../components/extensions/ErrorPageDefaults/NoTableData";
import { renderChartTitle } from "../../../../helpers/chartTitleBuilder";
import moment from "moment";
import { SetChartCustomerProfilingTitle } from "../../../../store/actions/reports/chart_title_actions";

const fromDate = new Date();
const toDate = new Date();

fromDate.setMonth(fromDate.getMonth());
toDate.setMonth(toDate.getMonth());

const customer_profiling_dates = {
  from: fromDate,
  to: toDate,
};

class CustomerProfiling extends Component {
  state = {
    dates: customer_profiling_dates,
    toView: "piece",
    clusterId: null,
    areaId: null,
    areaSelectContext: null,
    clusterSelectContext: null,
    isLoading: false,
  };

  componentDidMount() {
    this.setState({ isLoading: true });

    this.premiseGetCustomerProfile().then((resp) => {
      this.setState({ isLoading: false });
    });
  }

  renderOptions = () => {
    return (
      <Toolbar className="float-right">
        <IconButton
          onClick={() => {
            this.props.openModal({
              custom: false,
              size: "lg",
              title: "Customer Profiling",
              currentComponent: <CustomerProfileViewFilter />,
            });
          }}
        >
          <Search />
        </IconButton>
        <ModuleLocked
          Lock={() => this.context.Lock(moduleNames.customerProfiling)}
          Unlock={() => this.context.Unlock(moduleNames.customerProfiling)}
          isLocked={this.context.customerProfilingLocked}
        />
      </Toolbar>
    );
  };

  render() {
    var { customer_profiling_list } = this.props;

    return this.state.isLoading ? (
      <PieChartLoader />
    ) : (
      <div>
        {customer_profiling_list.length === 0 ? (
          <NoTableData />
        ) : (
          <div>
            <p className="small">{this.props.chartTitle}</p>
            <Table hover responsive="lg" size="sm" variant="light" striped>
              <thead>
                <tr>
                  <td>Type</td>
                  <td>Piece</td>
                  <td>Amount</td>
                </tr>
              </thead>
              <tbody>
                {this.props.customer_profiling_list.map((data) => {
                  return (
                    <tr key={data.pawnerType}>
                      <td>{data.pawnerType}</td>
                      <td>{numberWithCommas(data.totalPieces)}</td>
                      <td>{numberWithCommas(data.totalPrincipal, 2)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        )}
        {this.renderOptions()}
      </div>
    );
  }

  //            this.state.toView === "piece" ? 0 : 2
  premiseGetCustomerProfile = () => {
    var chartTitle = renderChartTitle(
      moduleNames.customerProfiling,
      OperationScope.overall,
      moment(this.state.dates.to).format("MMMM DD YYYY")
    );
    this.props.SetChartCustomerProfilingTitle(chartTitle);
    return this.props.GetCustomerProfileOverallV4({
      covered_date: this.state.dates.to,
      isRange: false,
    });
  };
}

const mapStateToProps = (state) => {
  return {
    chartTitle: state.chart_title.customerProfiling,
    customer_profiling_list: state.customer_profile.customer_profiling_list,
  };
};

const mapDispatchToProps = {
  openModal: openModal,
  SetChartCustomerProfilingTitle: SetChartCustomerProfilingTitle,
  GetCustomerProfileOverallV4: GetCustomerProfileOverallV4,
};

CustomerProfiling.contextType = DashboardContext;
export default connect(mapStateToProps, mapDispatchToProps)(CustomerProfiling);
